export { default as Truncate } from './truncate';
export { default as useTruncate } from './use-truncate';
//# sourceMappingURL=index.js.map